import { xuwoIconData, type XuwoIconName } from './data';

/** Named component exports map onto the canonical XuWo registry keys. */
export const namedIconNames = {
  AccountBanIcon: 'account-ban',
  AccountEnableIcon: 'account-enable',
  AccountIcon: 'person-single',
  AddCollectionIcon: 'add-collection',
  AddCommentIcon: 'add-comment',
  AddCursorDuotoneIcon: 'add-cursor-duotone',
  AddCursorIcon: 'add-cursor',
  AddOrganizeIcon: 'add-organize',
  AddTagIcon: 'add-tag',
  AddTextIcon: 'add-text',
  AdminIcon: 'admin',
  AiEmbeddingIcon: 'ai-embedding',
  AiIcon: 'ai',
  AiOutlineIcon: 'magic-wand',
  AiThinkingIcon: 'ai-thinking',
  AliasIcon: 'alias',
  AlignBottomIcon: 'align-bottom',
  AlignHorizontalCenterIcon: 'align-horizontal-center',
  AlignLeftIcon: 'align-left',
  AlignRightIcon: 'align-right',
  AlignTopIcon: 'align-top',
  AlignVerticalCenterIcon: 'align-vertical-center',
  AllDocsIcon: 'page',
  AppearanceIcon: 'appearance',
  AppleDuotoneIcon: 'apple-duotone',
  AppleIcon: 'apple',
  ArrowDownBigBottomIcon: 'arrow-down-big-bottom',
  ArrowDownBigIcon: 'arrow-down-big',
  ArrowDownSmallIcon: 'arrow-down-small',
  ArrowDownSmallPlusIcon: 'arrow-down-small-plus',
  ArrowLeftBigIcon: 'arrow-left-big',
  ArrowLeftSmallIcon: 'arrow-left-small',
  ArrowLeftSmallPlusIcon: 'arrow-left-small-plus',
  ArrowRightBigIcon: 'arrow-right-big',
  ArrowRightSmallIcon: 'arrow-right-small',
  ArrowRightSmallPlusIcon: 'arrow-right-small-plus',
  ArrowShapeIcon: 'arrow-shape',
  ArrowUpBigIcon: 'arrow-up-big',
  ArrowUpBigTopIcon: 'arrow-up-big-top',
  ArrowUpSmallIcon: 'arrow-up-small',
  ArrowUpSmallPlusIcon: 'arrow-up-small-plus',
  ArrowsLeftIcon: 'arrows-left',
  ArrowsRightIcon: 'arrows-right',
  AtIcon: 'at',
  AttachmentIcon: 'paper-clip',
  AutoHeightIcon: 'auto-height',
  AutoSizeIcon: 'auto-size',
  AutoTidyUpIcon: 'auto-tidy-up',
  BackwardPanelIcon: 'backward-panel',
  BagPanelIcon: 'bag-panel',
  BanIcon: 'ban',
  BaseballPanelIcon: 'baseball-panel',
  BasketballPanelIcon: 'basketball-panel',
  BitcoinPanelIcon: 'bitcoin-panel',
  BlockIcon: 'block',
  BlockLinkIcon: 'block-link',
  BlocksuiteIcon: 'blocksuite',
  BoldIcon: 'bold',
  BookPanelIcon: 'book-panel',
  BookmarkIcon: 'bookmark',
  BrokenImageIcon: 'broken-image',
  BroomIcon: 'broom',
  BrushIcon: 'paint-brush',
  BubbleIcon: 'bubble',
  BulletedList01Icon: 'bulleted-list01',
  BulletedList02Icon: 'bulleted-list02',
  BulletedList03Icon: 'bulleted-list03',
  BulletedList04Icon: 'bulleted-list04',
  BulletedListIcon: 'block-bulleted-list',
  CalendarPanelIcon: 'calendar',
  CalendarXmarkIcon: 'calendar-xmark',
  CameraIcon: 'camera',
  CameraPanelIcon: 'camera-panel',
  CancelWrapIcon: 'unwrap-content',
  CaptionIcon: 'caption-small',
  CardPanelIcon: 'card-panel',
  Cart2PanelIcon: 'cart2-panel',
  CartPanelIcon: 'cart-panel',
  CategoryPanelIcon: 'category-panel',
  CenterPeekIcon: 'peek-center',
  ChartPanelIcon: 'chart',
  ChatPanelIcon: 'chat-panel',
  ChatWithAiIcon: 'chat-with-ai',
  CheckBoxCheckLinearIcon: 'property-checkbox',
  CheckBoxCheckSolidIcon: 'check-box-check-solid',
  CheckBoxIntermediateIcon: 'check-box-intermediate',
  CheckBoxUnIcon: 'check-box-un',
  ChemicalPanelIcon: 'chemical-panel',
  CirclePanelIcon: 'circle-panel',
  ClaudeDuotoneIcon: 'claude-duotone',
  ClientIcon: 'client',
  CloseIcon: 'close',
  CloudBubbleIcon: 'cloud-bubble',
  CloudWorkspaceIcon: 'cloud-workspace',
  Cloudy2PanelIcon: 'cloudy2-panel',
  CloudyPanelIcon: 'cloudy-panel',
  CodeBlockIcon: 'block-code',
  CodeIcon: 'code',
  CodePanelIcon: 'code-panel',
  CoinPanelIcon: 'coin-panel',
  CollaborationIcon: 'collaboration',
  CollapseIcon: 'collapse',
  CollapseTabIcon: 'collapse-tab',
  CollectPanelIcon: 'collection',
  CollectionsIcon: 'collection',
  ColorPanelIcon: 'color-panel',
  ColorPickerIcon: 'color-picker',
  CommentDuodoneIcon: 'comment-duodone',
  CommentIcon: 'comment',
  CompressIcon: 'compress',
  Computer2PanelIcon: 'computer2-panel',
  ComputerPanelIcon: 'computer-panel',
  ConfusePanelIcon: 'confuse-panel',
  ConnectorCIcon: 'connector-c',
  ConnectorEIcon: 'connector-e',
  ConnectorLIcon: 'connector-l',
  ContactWithUsIcon: 'contact-with-us',
  ConvertIcon: 'convert',
  CopyAsImgaeIcon: 'copy-as-imgae',
  CopyIcon: 'duplicate',
  CornerIcon: 'corner',
  CreatedIcon: 'created',
  CropIcon: 'crop',
  CrossedCircleIcon: 'crossed-circle',
  CubePanelIcon: 'cube-panel',
  CurveLineIcon: 'curve-line',
  CustomSizeIcon: 'custom-size',
  CustomizedHeightIcon: 'customized-height',
  CylinderIcon: 'cylinder',
  DarkModeIcon: 'dark-mode',
  DashLineIcon: 'dash-line',
  Data2PanelIcon: 'data2-panel',
  DataPanelIcon: 'data-panel',
  DatabaseKanbanViewIcon: 'board',
  DatabaseListViewIcon: 'list',
  DatabaseTableViewIcon: 'table',
  DateTimeIcon: 'calendar',
  DeleteIcon: 'trash',
  DeletePermanentlyIcon: 'delete-permanently',
  DeleteTemporarilyIcon: 'trash',
  Diagonally_2LinesIcon: 'diagonally-2-lines',
  DiamondIcon: 'diamond',
  DirectionPanelIcon: 'direction-panel',
  DirectionSign2PanelIcon: 'direction-sign2-panel',
  DirectionSign3PanelIcon: 'direction-sign3-panel',
  DirectionSign4PanelIcon: 'direction-sign4-panel',
  DirectionSignPanelIcon: 'direction-sign-panel',
  DiscordDuotoneIcon: 'discord-duotone',
  DiscordIcon: 'discord',
  DiscordPanelIcon: 'discord',
  DistributeHorizontalIcon: 'distribute-horizontal',
  DistributeVerticalIcon: 'distribute-vertical',
  DividerIcon: 'block-divider',
  DocsDuotoneIcon: 'docs-duotone',
  DocsIcon: 'page',
  DoneIcon: 'done',
  DotDuotoneIcon: 'dot-duotone',
  DownloadIcon: 'arrow-line-down',
  DragCursorDuotoneIcon: 'drag-cursor-duotone',
  DragCursorIcon: 'drag-cursor',
  Drink2PanelIcon: 'drink2-panel',
  DrinkPanelIcon: 'drink-panel',
  DropCursorDuotoneIcon: 'drop-cursor-duotone',
  DropCursorIcon: 'drop-cursor',
  DualLinkIcon: 'dual-link',
  DuplicateIcon: 'duplicate',
  EdgelessIcon: 'edgeless',
  EditIcon: 'pencil',
  ElbowedLineIcon: 'elbowed-line',
  EllipseIcon: 'ellipse',
  EllipsisIcon: 'ellipsis',
  EmailIcon: 'email',
  EmailWarningIcon: 'email-warning',
  EmbedIcon: 'embed',
  EmbedWebIcon: 'embed-web',
  EmptyIcon: 'empty',
  EndPointArrowIcon: 'end-point-arrow',
  EndPointCircleIcon: 'end-point-circle',
  EndPointDiamondIcon: 'end-point-diamond',
  EndPointTriangleIcon: 'end-point-triangle',
  EnterIcon: 'enter',
  EqIcon: 'eq',
  EraserIcon: 'eraser',
  ExpandCloseIcon: 'expand-close',
  ExpandFullIcon: 'expand-full',
  ExpandIcon: 'expand-outline',
  ExpandWideIcon: 'expand-wide',
  ExperimentIcon: 'experiment',
  ExplainIcon: 'explain',
  ExportIcon: 'export',
  ExportToHtmlIcon: 'export-to-html',
  ExportToMarkdownIcon: 'export-to-markdown',
  ExportToPdfIcon: 'export-to-pdf',
  ExportToPngIcon: 'export-to-png',
  ExportToSvgIcon: 'export-to-svg',
  EyePanelIcon: 'eye',
  FacebookDuotoneIcon: 'facebook-duotone',
  FacebookIcon: 'facebook',
  FavoriteIcon: 'favorite',
  FavoritedIcon: 'favorited',
  FigmaDuotoneIcon: 'figma-duotone',
  FigmaIcon: 'figma',
  FileIcon: 'block-file',
  FileIconAepIcon: 'file-icon-aep',
  FileIconAiIcon: 'file-icon-ai',
  FileIconAviIcon: 'file-icon-avi',
  FileIconCssIcon: 'file-icon-css',
  FileIconCsvIcon: 'file-icon-csv',
  FileIconDmgIcon: 'file-icon-dmg',
  FileIconDocIcon: 'file-icon-doc',
  FileIconDocxIcon: 'file-icon-docx',
  FileIconEpsIcon: 'file-icon-eps',
  FileIconExeIcon: 'file-icon-exe',
  FileIconFigIcon: 'file-icon-fig',
  FileIconGifIcon: 'file-icon-gif',
  FileIconHtmlIcon: 'file-icon-html',
  FileIconImgIcon: 'file-icon-img',
  FileIconInddIcon: 'file-icon-indd',
  FileIconJavaIcon: 'file-icon-java',
  FileIconJpegIcon: 'file-icon-jpeg',
  FileIconJpgIcon: 'file-icon-jpg',
  FileIconJsIcon: 'file-icon-js',
  FileIconJsonIcon: 'file-icon-json',
  FileIconMdIcon: 'file-icon-md',
  FileIconMkvIcon: 'file-icon-mkv',
  FileIconMp3Icon: 'file-icon-mp3',
  FileIconMp4Icon: 'file-icon-mp4',
  FileIconMpegIcon: 'file-icon-mpeg',
  FileIconNoneIcon: 'file-icon-none',
  FileIconPdfIcon: 'file-icon-pdf',
  FileIconPngIcon: 'file-icon-png',
  FileIconPptIcon: 'file-icon-ppt',
  FileIconPptxIcon: 'file-icon-pptx',
  FileIconPsdIcon: 'file-icon-psd',
  FileIconRarIcon: 'file-icon-rar',
  FileIconRssIcon: 'file-icon-rss',
  FileIconSketchIcon: 'file-icon-sketch',
  FileIconSqlIcon: 'file-icon-sql',
  FileIconSvgIcon: 'file-icon-svg',
  FileIconTiffIcon: 'file-icon-tiff',
  FileIconTxtIcon: 'file-icon-txt',
  FileIconWavIcon: 'file-icon-wav',
  FileIconWebpIcon: 'file-icon-webp',
  FileIconXlsIcon: 'file-icon-xls',
  FileIconXlsxIcon: 'file-icon-xlsx',
  FileIconXmlIcon: 'file-icon-xml',
  FileIconZipIcon: 'file-icon-zip',
  FilePanelIcon: 'file-panel',
  FilterIcon: 'filter',
  FilterMinusIcon: 'filter-minus',
  FilterUndoIcon: 'filter-undo',
  FilteredIcon: 'filtered',
  FirePanelIcon: 'fire-panel',
  Flag2PanelIcon: 'flag2-panel',
  Flag3PanelIcon: 'flag3-panel',
  FlagPanelIcon: 'flag',
  FlashPanelIcon: 'flash-panel',
  FlipDirectionIcon: 'flip-direction',
  FlowerPanelIcon: 'flower-panel',
  Folder2PanelIcon: 'folder2-panel',
  Folder3PanelIcon: 'folder3-panel',
  FolderIcon: 'folder',
  FolderPanelIcon: 'folder-panel',
  FontIcon: 'font',
  FoodPanelIcon: 'food-panel',
  ForwardPanelIcon: 'forward-panel',
  ForwardThirtySecondsIcon: 'forward-thirty-seconds',
  FrameIcon: 'frame',
  FruitPanelIcon: 'fruit-panel',
  FullDayIcon: 'full-day',
  GamePanelIcon: 'game-panel',
  GeminiDuotoneIcon: 'gemini-duotone',
  GiftPanelIcon: 'gift-panel',
  GithubDuotoneIcon: 'github-duotone',
  GithubIcon: 'github',
  GithubPanelIcon: 'github-panel',
  GitlabDuotoneIcon: 'gitlab-duotone',
  GitlabIcon: 'gitlab',
  GobletPanelIcon: 'goblet-panel',
  GoodIcon: 'good',
  GoogleDuotoneIcon: 'google-duotone',
  GoogleIcon: 'google',
  GoogleMapDuotoneIcon: 'google-map-duotone',
  GoogleMapIcon: 'google-map',
  GooglePanelIcon: 'google-panel',
  GptDuotoneIcon: 'gpt-duotone',
  GridIcon: 'grid',
  GroupIcon: 'board-group',
  GroupPanelIcon: 'group-panel',
  GroupingIcon: 'grouping',
  GtIcon: 'gt',
  HamburgerPanelIcon: 'hamburger-panel',
  HandIcon: 'hand',
  HappyPanelIcon: 'happy-panel',
  HeaderColumnIcon: 'header-column',
  HeaderRowIcon: 'header-row',
  Heading1Icon: 'block-heading-1',
  Heading2Icon: 'block-heading-2',
  Heading3Icon: 'block-heading-3',
  Heading4Icon: 'block-heading-4',
  Heading5Icon: 'heading5',
  Heading6Icon: 'heading6',
  HeadingsIcon: 'headings',
  HeadphonePanelIcon: 'headphone-panel',
  HeartPanelIcon: 'heart-panel',
  HeartbreakIcon: 'heartbreak',
  HelpCenterIcon: 'help-center',
  HelpIcon: 'question-mark-circle',
  HexagonIcon: 'hexagon',
  HidePanelIcon: 'hide-panel',
  HighHeelPanelIcon: 'high-heel-panel',
  HighLightDuotoneIcon: 'high-light-duotone',
  HighLightLinearIcon: 'high-light-linear',
  HistoryIcon: 'history',
  HomeIcon: 'home',
  HomePanelIcon: 'home-panel',
  ImageIcon: 'photo',
  ImagePanelIcon: 'photo',
  ImportIcon: 'import',
  ImproveWritingIcon: 'improve-writing',
  InboxIcon: 'inbox',
  InfoIcon: 'info-circle',
  InformationFillDuotoneIcon: 'information-fill-duotone',
  InformationIcon: 'info-circle',
  InformationPanelIcon: 'info-circle',
  InsertAboveIcon: 'insert-above',
  InsertBelowIcon: 'insert-below',
  InsertBleowIcon: 'insert-bleow',
  InsertBlocksIcon: 'insert-blocks',
  InsertIntoPageIcon: 'insert-into-page',
  InsertLeftIcon: 'insert-left',
  InsertRightIcon: 'insert-right',
  InsertTopIcon: 'insert-top',
  InstagramDuotoneIcon: 'instagram-duotone',
  InstagramIcon: 'instagram',
  InsyncIcon: 'insync',
  IntegrationsIcon: 'integrations',
  InvisibleIcon: 'eye-slash',
  IssueIcon: 'issue',
  ItalicIcon: 'italic',
  JournalIcon: 'calendar-date',
  KeyboardIcon: 'keyboard',
  LanguageIcon: 'translate',
  LayerIcon: 'layer',
  LayoutIcon: 'layout',
  LeafPanelIcon: 'cat-leaf',
  LeftBracketIcon: 'left-bracket',
  LiftPanelIcon: 'lift-panel',
  LightModeIcon: 'light-mode',
  LightPanelIcon: 'cat-light-bulb',
  LineStyleIcon: 'line-style',
  LinearLogoDuotoneIcon: 'linear-logo-duotone',
  LinearLogoIcon: 'linear-logo',
  LinkBlockIcon: 'block-link-to-page',
  LinkIcon: 'link',
  LinkedEdgelessIcon: 'linked-edgeless',
  LinkedPageIcon: 'linked-page',
  LoadingIcon: 'loading',
  LocalDataIcon: 'local-data',
  LocalWorkspaceIcon: 'local-workspace',
  LocateIcon: 'locate',
  LockIcon: 'lock',
  LockPanelIcon: 'lock',
  Logo1DuotoneIcon: 'logo1-duotone',
  Logo1Icon: 'logo1',
  Logo2DuotoneIcon: 'logo2-duotone',
  Logo2Icon: 'logo2',
  Logo3DuotoneIcon: 'logo3-duotone',
  Logo3Icon: 'logo3',
  Logo4DuotoneIcon: 'logo4-duotone',
  Logo4Icon: 'logo4',
  LongSleevePanelIcon: 'long-sleeve-panel',
  LongerIcon: 'longer',
  LoomLogoDuotoneIcon: 'loom-logo-duotone',
  LoomLogoIcon: 'loom-logo',
  LtIcon: 'lt',
  MailPanelIcon: 'mail-panel',
  MailboxPanelIcon: 'mailbox-panel',
  MakeItRealIcon: 'make-it-real',
  MapPanelIcon: 'map',
  MathPanelIcon: 'math-panel',
  McpIcon: 'mcp',
  MeetingIcon: 'meeting',
  MemberIcon: 'person-single',
  MenubarIcon: 'menubar',
  MicPanelIcon: 'mic-panel',
  MicrophoneIcon: 'microphone',
  MindmapIcon: 'mindmap',
  MindmapNodeIcon: 'mindmap-node',
  MinusIcon: 'minus',
  MoonPanelIcon: 'moon-panel',
  MoreHorizontalIcon: 'ellipsis',
  MoreVerticalIcon: 'more-vertical',
  MountainPanelIcon: 'mountain-panel',
  MousePanelIcon: 'mouse-panel',
  MoveLeftIcon: 'move-left',
  MoveRightIcon: 'move-right',
  MoveToIcon: 'move',
  MoveToLeftDuotoneIcon: 'move-to-left-duotone',
  MoveToRightDuotoneIcon: 'move-to-right-duotone',
  MoviePanelIcon: 'movie-panel',
  MultiCursorDuotoneIcon: 'multi-cursor-duotone',
  MultiPeopleIcon: 'people',
  MultiSelectIcon: 'multi-select',
  NeIcon: 'ne',
  NewIcon: 'new',
  NewPageIcon: 'new-page',
  NewXxxEdgelessIcon: 'new-xxx-edgeless',
  NewXxxPageIcon: 'new-xxx-page',
  NightPanelIcon: 'night-panel',
  NoNetworkIcon: 'no-network',
  NoteShadowDuotoneIcon: 'note-shadow-duotone',
  NotificationIcon: 'bell',
  NotionDuotoneIcon: 'notion-duotone',
  NotionIcon: 'notion',
  NowIcon: 'now',
  NumberIcon: 'property-number',
  NumberedListIcon: 'block-numbered-list',
  OctobaseIcon: 'octobase',
  OpenInNewIcon: 'open-in-new',
  OtherIcon: 'other',
  PageIcon: 'page',
  PaletteIcon: 'palette',
  ParallelogramIcon: 'parallelogram',
  PasteIcon: 'paste',
  PausePanelIcon: 'pause-panel',
  PaymentIcon: 'payment',
  PeacePanelIcon: 'peace-panel',
  PenIcon: 'pen',
  PenThickIcon: 'pen-thick',
  PenThickLeftIcon: 'pen-thick-left',
  PenThinIcon: 'pen-thin',
  PeriodIcon: 'period',
  PersonPanelIcon: 'person-single',
  PhonePanelIcon: 'property-phone',
  PickerPanelIcon: 'picker-panel',
  PillIcon: 'pill',
  PinIcon: 'pin',
  PinedIcon: 'pined',
  PlanetPanelIcon: 'planet-panel',
  PlayFillIcon: 'play-fill',
  PlayIcon: 'play-outline',
  PlayPanelIcon: 'play-panel',
  PluginIcon: 'plugin',
  PlusIcon: 'plus',
  PlusThickIcon: 'plus-thick',
  PptIcon: 'ppt',
  Presentation2PanelIcon: 'presentation2-panel',
  PresentationIcon: 'play',
  PresentationPanelIcon: 'presentation-panel',
  PrinterIcon: 'printer',
  ProductHuntDuotoneIcon: 'product-hunt-duotone',
  ProductHuntIcon: 'product-hunt',
  ProgressIcon: 'progress',
  PropertyIcon: 'property',
  PublishIcon: 'publish',
  QrCodePanelIcon: 'qr-code-panel',
  QuoteIcon: 'block-quote',
  RadiantIcon: 'radiant',
  RainPanelIcon: 'rain-panel',
  ReadwiseIcon: 'readwise',
  ReadwiseLogoDuotoneIcon: 'readwise-logo-duotone',
  ReauthenticationIcon: 'reauthentication',
  RecentIcon: 'clock',
  RedditDuotoneIcon: 'reddit-duotone',
  RedditIcon: 'reddit',
  RedoIcon: 'redo',
  ReleaseFromGroupIcon: 'release-from-group',
  RemoveFolderIcon: 'remove-folder',
  RemoveIcon: 'remove',
  ReplaceIcon: 'replace',
  ResetIcon: 'reset',
  ResizeTidyUpIcon: 'resize-tidy-up',
  RewindFifteenSecondsIcon: 'rewind-fifteen-seconds',
  RightBracketIcon: 'right-bracket',
  RightLayoutIcon: 'right-layout',
  RightSidebarIcon: 'right-sidebar',
  RightTabIcon: 'right-tab',
  RotateAnticlockwiseIcon: 'rotate-anticlockwise',
  RotateIcon: 'rotate',
  RoundedRectangleIcon: 'rounded-rectangle',
  RoundedSquareIcon: 'rounded-square',
  RulerPanelIcon: 'ruler-panel',
  SadPanelIcon: 'sad-panel',
  SaveIcon: 'save',
  ScaleAltIcon: 'scale-alt',
  ScaleIcon: 'scale',
  ScissorsIcon: 'scissors',
  SearchIcon: 'magnifying-glass-small',
  SelectAreaIcon: 'select-area',
  SelectIcon: 'select',
  SelectTextIcon: 'select-text',
  SelectionIcon: 'selection',
  SelfhostIcon: 'selfhost',
  SendIcon: 'send',
  SettingsIcon: 'gear',
  SettingsPanelIcon: 'gear',
  ShapeIcon: 'shape',
  ShareIcon: 'share',
  SharedIcon: 'shared',
  ShareiOsIcon: 'sharei-os',
  ShoesPanelIcon: 'shoes-panel',
  ShortPantsPanelIcon: 'short-pants-panel',
  ShorterIcon: 'shorter',
  SiblingNodeIcon: 'sibling-node',
  SidebarDuotoneIcon: 'sidebar-duotone',
  SidebarIcon: 'sidebar',
  SignOutIcon: 'sign-out',
  SignalIcon: 'signal',
  SignalPanelIcon: 'signal-panel',
  SingleSelectCheckSolidIcon: 'single-select-check-solid',
  SingleSelectIcon: 'single-select',
  SingleSelectSelectLinearIcon: 'single-select-select-linear',
  SingleSelectUnIcon: 'ellipse',
  SkateboardPanelIcon: 'skateboard-panel',
  SkirtPanelIcon: 'skirt-panel',
  SmileIcon: 'smile',
  SmilePanelIcon: 'smile-panel',
  SmileSolidIcon: 'smile-solid',
  Snow2PanelIcon: 'snow2-panel',
  SnowMountainPanelIcon: 'snow-mountain-panel',
  SnowPanelIcon: 'snow-panel',
  SocketPanelIcon: 'socket-panel',
  SoloViewIcon: 'solo-view',
  SortDownIcon: 'sort-down',
  SortIcon: 'sort',
  SortUpIcon: 'sort-up',
  SplitViewIcon: 'split-view',
  SquareIcon: 'square',
  StarIcon: 'star',
  StarPanelIcon: 'star',
  StartNumberingIcon: 'start-numbering',
  StartPointArrowIcon: 'start-point-arrow',
  StartPointCircleIcon: 'start-point-circle',
  StartPointDiamondIcon: 'start-point-diamond',
  StartPointIcon: 'start-point',
  StartPointTriangleIcon: 'start-point-triangle',
  StopAiIcon: 'stop-ai',
  StopIcon: 'stop',
  StraightLineIcon: 'straight-line',
  StrikeThroughIcon: 'strike-through',
  StyleGeneralIcon: 'style-general',
  StyleIcon: 'style',
  StyleScribbleIcon: 'style-scribble',
  SubNodeIcon: 'sub-node',
  SucessfulDuotoneIcon: 'sucessful-duotone',
  SucessfulIcon: 'sucessful',
  SuitcasePanelIcon: 'suitcase-panel',
  SummarizeIcon: 'summarize',
  SunPanelIcon: 'sun-panel',
  SunglassPanelIcon: 'sunglass-panel',
  TShirtPanelIcon: 't-shirt-panel',
  TableIcon: 'table',
  TagIcon: 'property-select',
  TagPanelIcon: 'tag-panel',
  TagsIcon: 'tags',
  TeXDuotoneIcon: 'te-x-duotone',
  TeXIcon: 'te-x',
  TeamWorkspaceIcon: 'team-workspace',
  TelegramDuotoneIcon: 'telegram-duotone',
  TelegramIcon: 'telegram',
  TemplateColoredIcon: 'template-colored',
  TemplateIcon: 'template',
  TemplateOutlineIcon: 'template-outline',
  TextAlignBottomIcon: 'text-align-bottom',
  TextAlignCenterIcon: 'text-align-center',
  TextAlignLeftIcon: 'text-align-left',
  TextAlignMediumIcon: 'text-align-medium',
  TextAlignRightIcon: 'text-align-right',
  TextAlignTopIcon: 'text-align-top',
  TextBackgroundDuotoneIcon: 'text-background-duotone',
  TextColorIcon: 'text-color',
  TextIcon: 'block-text',
  TextTypeIcon: 'text-type',
  ThinkingIcon: 'thinking',
  TimePanelIcon: 'clock',
  TimelineIcon: 'timeline',
  TitleIcon: 'title',
  TocIcon: 'toc',
  TodayIcon: 'today',
  ToggleDownIcon: 'toggle-down',
  ToggleLeftIcon: 'toggle-left',
  ToggleRightIcon: 'toggle-right',
  ToggleUpIcon: 'toggle-up',
  TomorrowIcon: 'tomorrow',
  ToneIcon: 'tone',
  ToolIcon: 'tool',
  TranscriptWithAiIcon: 'transcript-with-ai',
  TreePanelIcon: 'tree-panel',
  TriangleIcon: 'triangle',
  TriangleRulerPanelIcon: 'triangle-ruler-panel',
  TwitterDuotoneIcon: 'twitter-duotone',
  TwitterIcon: 'twitter',
  UmbrellaPanelIcon: 'umbrella-panel',
  UnderLineIcon: 'under-line',
  UndoIcon: 'undo',
  UngroupIcon: 'ungroup',
  UnlinkIcon: 'unlink',
  UnlockIcon: 'unlock',
  UnpinIcon: 'unpin',
  UnsucessfulDuotoneIcon: 'unsucessful-duotone',
  UnsucessfulIcon: 'unsucessful',
  UnsyncIcon: 'unsync',
  UpdatedIcon: 'updated',
  UpgradeIcon: 'upgrade',
  UploadIcon: 'upload',
  UsbPanelIcon: 'usb-panel',
  UserGuideIcon: 'user-guide',
  UserIcon: 'person-single',
  VerticalCylinderIcon: 'vertical-cylinder',
  ViewBarIcon: 'view-bar',
  ViewIcon: 'view',
  ViewLayersIcon: 'view-layers',
  VoiceIcon: 'voice',
  VolumePanelIcon: 'block-audio',
  WalletPanelIcon: 'wallet-panel',
  WarningIcon: 'warning',
  WaveRectangleIcon: 'wave-rectangle',
  WebIcon: 'web',
  WindmillPanelIcon: 'windmill-panel',
  WindowPanelIcon: 'window-panel',
  WrapIcon: 'wrap-content',
  YesterdayIcon: 'yesterday',
  YoutubeDuotoneIcon: 'youtube-duotone',
  YoutubeIcon: 'youtube',
  YoutubePanelIcon: 'youtube-panel',
  ZendeskDuotoneIcon: 'zendesk-duotone',
  ZendeskIcon: 'zendesk',
  ZipIcon: 'zip',
  ZoomDownIcon: 'zoom-down',
  ZoomUpIcon: 'zoom-in-small',
  DashboardIcon: 'dashboard',
  TodoListIcon: 'block-todo-list',
  DatabaseIcon: 'database',
  ChevronLeftIcon: 'chevron-left',
  ChevronRightIcon: 'chevron-right',
  ChevronDownIcon: 'chevron-down-small',
  ChevronRightMediumIcon: 'chevron-right-medium',
} satisfies Record<string, XuwoIconName>;

export function resolveXuwoIconName(name: string): XuwoIconName | undefined {
  if (Object.hasOwn(xuwoIconData, name)) return name as XuwoIconName;
  const key = name.endsWith('Icon') ? name : name + 'Icon';
  if (Object.hasOwn(namedIconNames, key))
    return namedIconNames[key as keyof typeof namedIconNames];
  const capitalized = key.charAt(0).toUpperCase() + key.slice(1);
  return Object.hasOwn(namedIconNames, capitalized)
    ? namedIconNames[capitalized as keyof typeof namedIconNames]
    : undefined;
}
